import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OrderRepaymentState, ValidationChecks } from './order-repayment.state';

import { CartService } from '@api/cart/cart.service';
import { Order } from '@api/order/order.models';
import { MoneyHelpers } from '@api/util/money.helpers';
import { CurrencyInfo } from '@core/domain/models/store.models';
import { getCurrencyInfo } from '@core/infrastructure/state/core.selectors';

const orderRepaymentState = createFeatureSelector<OrderRepaymentState>('order-repayment');

export const getCurrentOrder = createSelector(orderRepaymentState, (state: OrderRepaymentState) => state?.order);

export const getStatus = createSelector(orderRepaymentState, (state: OrderRepaymentState) => state.status);

export const getRepaymentTotalOrderFormatted = createSelector(
    getCurrentOrder,
    getCurrencyInfo,
    (order: Order, currencyInfo: CurrencyInfo) => {
        return MoneyHelpers.formatPriceWithCurrencySymbol(order?.totalOrder, currencyInfo);
    }
);

export const getTotalProducts = createSelector(getCurrentOrder, (order: Order) => {
    const items = (order?.items || []).map((item) => item as any);
    return CartService.getItemsQuantity(items);
});

export const areTheRepayValidationsOk = createSelector(orderRepaymentState, (state: OrderRepaymentState) =>
    Object.values(state?.validationChecks).every((validationOk) => validationOk));

export const repayValidationErrors = createSelector(orderRepaymentState, (state: OrderRepaymentState) => {
    const obj = Object.entries(state?.validationChecks).reduce((acc, [key, value]) => {
        if (!value) {
            acc[key] = value;
        }
        return acc;
    }, {});
    return obj as ValidationChecks;
});
